import React from 'react';

import './styles.scss';

const LoadingInput = ({ loading, children }) => {
    return (
        <div id="LoadingInput">
            <div className={`loading-spinner-grow ${loading && "spinner-grow spinner-grow-sm"}`} role="status">
                <span className="sr-only">Loading...</span>
            </div>
            {children}
        </div>
    );
};

export default LoadingInput;